import { apiService } from "./api";

export type AuditLogUser = {
  first_name: string;
  last_name: string;
  id: string;
  image_url: string;
};

export type AuditLogEntry = {
  id: string;
  user: AuditLogUser;
  entity: string;
  action: string;
  status: "Success" | "Failed" | "Failure" | "SUCCESS" | "FAILED" | "FAILURE" | "Redirect" | "Unknown";
  timestamp: string;
  details: {
    firstName: string;
    middleName?: string;
    entity: string;
    action: string;
    status: string;
    timestamp: string;
    loggedBy: string;
    staffRoleId: string;
  }
};

export type AuditLogResponse = {
  status?: boolean;
  data: AuditLogEntry[];
  pagination: {
    total: number;
    page: number;
    total_pages: number;
    limit: number;
  };
  message: string;
};

type AuditLogParams = {
  page: number;
  limit: number;
  search?: string;
  category?: string[];
  action?: string[];
  status?: string[];
  sortBy?: "date";
  sortOrder?: "asc" | "desc";
};

export type FetchAuditLogsParams = {
  organizationId: string;
  page: number;
  limit: number;
  search?: string;
  category?: string[];
  action?: string[];
  status?: string[];
  sortBy?: "date";
  sortOrder?: "asc" | "desc";
};

export type AuditLogCategoriesResponse = {
  status: boolean;
  message: string;
  data: string[];
};

export async function fetchAuditLogs({
  organizationId,
  page,
  limit,
  search,
  category,
  action,
  status,
  sortBy = "date",
  sortOrder = "desc",
}: FetchAuditLogsParams) {
  const params: AuditLogParams = { page, limit, sortBy, sortOrder };

  if (search) {
    params.search = search;
  }
  if (category?.length) {
    params.category = category;
  }
  if (action?.length) {
    params.action = action;
  }
  if (status?.length) {
    params.status = status;
  }

  const response = await apiService({
    url: `/audit-log/organization/${organizationId}`,
    method: "get",
    params,
    protectedRoute: true,
  });

  return response as AuditLogResponse;
}

export async function fetchAuditLogCategories(organizationId: string) {
  const response = await apiService({
    url: `/audit-log/organization/${organizationId}/categories`,
    method: "get",
    protectedRoute: true,
  });

  return response as AuditLogCategoriesResponse;
}
